import React, { FC, useState, useEffect, memo, useRef } from "../../../lib/teact/teact";
import Button from "../../ui/Button";
import Checkbox from "../../ui/Checkbox";
import ConfirmDialog from "../../ui/ConfirmDialog";
import InputText from "../../ui/InputText";
import MessageEditor from "../message/messageEditor";
import { ContactsApi } from "../restapi/contactsApi";
import worker from "../setupWorker";
import store from "../store";
import LotCheckBox from "../ui/lotCheckBox";
import MyTextInput from "../ui/myTextInput";
import { GetUserID } from "../utils/common";

type OwnProps = {

}
interface IDataChanSoHang {
    userId: number;
    ngay: string;
    chanLo2c: number;
    chanXien: number;
    chanLo3c: number;
    chanLo4c: number;
    chanDau: number;
    chanDuoi: number;
    daiChanMn: string;
    daiChanMt: string;
    daiChanMb: string;
    chanLo2cDiem: number;
    chanXienDiem: number;
    chanLo3cDiem: number;
    chanLo4cDiem: number;
    chanDauDiem: number;
    chanDuoiDiem: number;
    daySo: string;
    daySoDau: string;
    daySoDuoi: string;
}
const ChanSoHang: FC<OwnProps> = ({

}) => {
    const refLo = useRef<HTMLDivElement>(null)
    const refDau = useRef<HTMLDivElement>(null)
    const refDuoi = useRef<HTMLDivElement>(null)
    const [state, setState] = useState({

        daiMn: [] as string[],
        daiMt: [] as string[],

        chanSoHang: {
            userId: Number(GetUserID()),
            ngay: store.getState().global.workDate,
            chanLo2c: 0,
            chanXien: 0,
            chanLo3c: 0,
            chanLo4c: 0,
            chanDau: 0,
            chanDuoi: 0,
            daiChanMn: "",
            daiChanMt: "",
            daiChanMb: "",
            daySo: "",
            daySoDau: "",
            daySoDuoi: "",
        } as IDataChanSoHang,
        chanDaiOpen: false,
        chanSoOpen: false,
    }
    )
    useEffect(() => {
        const payload = { ngay: store.getState().global.workDate }
        ContactsApi.getDaiQuayTrongNgay(payload).then(res => {
            setState(prev => ({ ...prev, daiMn: res.data.daiMn, daiMt: res.data.daiMt }))

        })
        ContactsApi.getChanSoHang(payload).then(res => {
            setState(prev => ({ ...prev, chanSoHang: res.data }))
            refLo.current!.innerHTML = res.data.daySo
            refDau.current!.innerHTML = res.data.daySoDau
            refDuoi.current!.innerHTML = res.data.daySoDuoi
        })
    }, [])
    function handleChanOnChange(e: React.ChangeEvent<HTMLInputElement>) {
        const id = e.target.id
        const value = Number(e.target.value)
        const checked = e.target.checked ? 1 : 0
        const tmp = Object.assign(state.chanSoHang) as IDataChanSoHang
        let num: number = 0
        if (!isNaN(value)) {
            num = value
        }
        switch (id) {
            case "chanLo2c":
                tmp.chanLo2c = checked
                break;
            case "chanXien":
                tmp.chanXien = checked
                break;
            case "chanLo3c":
                tmp.chanLo3c = checked
                break;
            case "chanLo4c":
                tmp.chanLo4c = checked
                break;
            case "chanDau":
                tmp.chanDau = checked
                break;
            case "chanDuoi":
                tmp.chanDuoi = checked
                break;
            case "chanLo2cDiem":
                tmp.chanLo2cDiem = num
                break;
            case "chanXienDiem":
                tmp.chanXienDiem = num
                break;
            case "chanLo3cDiem":
                tmp.chanLo3cDiem = num
                break;
            case "chanLo4cDiem":
                tmp.chanLo4cDiem = num
                break;
            case "chanDauDiem":
                tmp.chanDauDiem = num
                break;
            case "chanDuoiDiem":
                tmp.chanDuoiDiem = num
                break;

        }
        console.log(`id=${id} value:${value}`)
        return
    }
    function handleDaiChanMnChange(e: React.ChangeEvent<HTMLInputElement>) {
        console.log(`id:${e.target.id},value: ${e.target.value}`)
        const dai = e.target.value;
        const tmp: string[] = state.chanSoHang.daiChanMn.split(",")
        const chanSoHang = state.chanSoHang
        var filteredArray = tmp.filter(function (item) {
            return item !== dai && item != '';
        });
        if (e.target.checked) {
            filteredArray.push(dai)
        }
        chanSoHang.daiChanMn = filteredArray.join(",")
        setState(prev => ({ ...prev, chanSoHang: chanSoHang }))
        console.log(state.chanSoHang)
    }
    function handleDaiChanMtChange(e: React.ChangeEvent<HTMLInputElement>) {
        console.log(`id:${e.target.id},value: ${e.target.value}`)
        const dai = e.target.value;
        const tmp: string[] = state.chanSoHang.daiChanMt.split(",")
        const chanSoHang = state.chanSoHang
        var filteredArray = tmp.filter(function (item) {
            return item !== dai && item != '';
        });
        if (e.target.checked) {
            filteredArray.push(dai)
        }
        chanSoHang.daiChanMt = filteredArray.join(",")
        setState(prev => ({ ...prev, chanSoHang: chanSoHang }))
        console.log(state.chanSoHang)
    }
    function handleDaiChanMbChange(e: React.ChangeEvent<HTMLInputElement>) {
        console.log(`id:${e.target.id},value: ${e.target.value}`)
        const dai = e.target.value;
        const tmp: string[] = state.chanSoHang.daiChanMb.split(",")
        const chanSoHang = state.chanSoHang
        var filteredArray = tmp.filter(function (item) {
            return item !== dai && item != '';
        });
        if (e.target.checked) {
            filteredArray.push(dai)
        }
        chanSoHang.daiChanMb = filteredArray.join(",")
        setState(prev => ({ ...prev, chanSoHang: chanSoHang }))
        console.log(state.chanSoHang)
    }
    function handleSaveChanSoHang() {
        const textLo = refLo.current?.innerText
        const chanSoHang = Object.assign(state.chanSoHang)
        if (textLo) {
            chanSoHang.daySo = textLo
        }
        //
        const textDau = refDau.current?.innerText
        if (textDau) {
            chanSoHang.daySoDau = textDau
        }
        const textDuoi = refDuoi.current?.innerText
        if (textDuoi) {
            chanSoHang.daySoDuoi = textDuoi
        }
        setState(prev => ({ ...prev, chanSoHang: chanSoHang, chanSoOpen: false }))
        ContactsApi.saveChanSoHang(state.chanSoHang).then(res => {
            worker.postMessage({ type: 'showsnackbar', data: res.responseText })
        })
    }
    function handleSaveChanDai() {

        setState(prev => ({ ...prev, chanDaiOpen: false }))
        let dais = ""
        if (state.chanSoHang.daiChanMb != "")
            dais = state.chanSoHang.daiChanMb
        if (state.chanSoHang.daiChanMt != "")
            dais += dais == "" ? state.chanSoHang.daiChanMt : `,${state.chanSoHang.daiChanMt}`
        if (state.chanSoHang.daiChanMn != "")
            dais += dais == "" ? state.chanSoHang.daiChanMn : `,${state.chanSoHang.daiChanMn}`
        const payload = { ngay: store.getState().global.workDate, dais: dais }
        ContactsApi.saveChanDai(payload).then(res => {
            worker.postMessage({ type: 'showsnackbar', data: res.responseText })
        })

    }
    function openChanDai() {
        setState(prev => ({ ...prev, chanDaiOpen: true }))
    }
    function openChanSo() {
        setState(prev => ({ ...prev, chanSoOpen: true }))
    }
    return (
        <div className=" form-content">
            <div>Danh sách số chặn:LÔ</div>
            <div>
                <div className=" editable-div" contentEditable={true}
                    style={`height:100px;text-wrap:wrap;`}
                    ref={refLo}
                ></div>
            </div>
            <div className=" common-container-row align-top">
                <Checkbox label="Chặn lô 2C" checked={state.chanSoHang.chanLo2c == 1}
                    id="chanLo2c"
                    onChange={handleChanOnChange} />
                <MyTextInput label="" id={"chanLo2cDiem"}
                    onChange={handleChanOnChange}
                    value={state.chanSoHang.chanLo2cDiem} />
            </div>
            <div className=" common-container-row align-top">
                <Checkbox label="Chặn đá thẳng" checked={state.chanSoHang.chanXien == 1}
                    id="chanXien"
                    onChange={handleChanOnChange} />
                <MyTextInput label="" id={"chanXienDiem"} onChange={handleChanOnChange}
                    value={state.chanSoHang.chanXienDiem} />
            </div>
            <div className=" common-container-row align-top">
                <Checkbox label="Chặn lô 3C" checked={state.chanSoHang.chanLo3c == 1}
                    id="chanLo3c"
                    onChange={handleChanOnChange} />
                <MyTextInput label="" id={"chanLo3cDiem"} onChange={handleChanOnChange}
                    value={state.chanSoHang.chanLo3cDiem} />
            </div>

            <div className=" common-container-row align-top">
                <div>Danh sách số chặn:ĐẦU</div>
                <MyTextInput label="" id={"chanDauDiem"} onChange={handleChanOnChange}
                    value={state.chanSoHang.chanDauDiem} />
            </div>
            <div>
                <div className=" editable-div" contentEditable={true}
                    style={
                        `height:100px;text-wrap:wrap;`
                    }
                    ref={refDau}
                ></div>
            </div>


            <div className=" common-container-row align-top">
                <div>Danh sách số chặn:ĐUÔI</div>
                <MyTextInput label="" id={"chanDuoiDiem"} onChange={handleChanOnChange}
                    value={state.chanSoHang.chanDuoiDiem} />
            </div>
            <div>
                <div className=" editable-div" contentEditable={true}
                    style={
                        `height:100px;text-wrap:wrap;`
                    }
                    ref={refDuoi}
                ></div>
            </div>

            <div className=" common-container-row left-panel">
                {
                    state.daiMn.map(item => {
                        return <LotCheckBox text={item} value={item}
                            checked={state.chanSoHang.daiChanMn.includes(item)}
                            onChange={handleDaiChanMnChange}
                        >

                        </LotCheckBox>
                    })
                }
            </div>
            <div className=" common-container-row left-panel">
                {
                    state.daiMt.map(item => {
                        return <LotCheckBox text={item} value={item}
                            checked={state.chanSoHang.daiChanMt.includes(item)}
                            onChange={handleDaiChanMtChange}>

                        </LotCheckBox>
                    })
                }
                <LotCheckBox text={"HN"} value={"HN"}
                    checked={state.chanSoHang.daiChanMb.includes("HN")}
                    onChange={handleDaiChanMbChange}>

                </LotCheckBox>
            </div>
            <div className=" common-container-row center"  >
                <div style="width:300px;">
                    <Button onClick={openChanSo} size="tiny">Chặn Ds số</Button>
                </div>

            </div>
            <div className=" common-container-row center"  >

                <div style="width:300px;">
                    <Button onClick={openChanDai} size="tiny" >Chặn toàn bộ đài</Button>
                </div>
            </div>
            <ConfirmDialog isOpen={state.chanDaiOpen}
                confirmLabel="Xác nhận"
                confirmHandler={() => { handleSaveChanDai() }}
                onClose={() => setState(prev => ({ ...prev, chanDaiOpen: false }))}
                title="Chặn toàn bộ đài"
                text={"Hệ thống sẽ chặn toàn bộ các đài bạn chọn, không nhận bất kỳ thứ gì có liên quan đến những đài này (áp dụng cho mọi khách hàng, tất cả các loại cược). Chặn có hiệu lực trong 1 ngày."
                    + " Bỏ đánh dấu tất cả các đài để xoá chặn."
                }
            >

            </ConfirmDialog>
            <ConfirmDialog isOpen={state.chanSoOpen}
                confirmLabel="Xác nhận"
                confirmHandler={() => { handleSaveChanSoHang() }}
                onClose={() => setState(prev => ({ ...prev, chanSoOpen: false }))}
                title="Chặn toàn ds số"
                text={"Hệ thống sẽ chặn danh sách số theo từng đài bạn chọn (áp dụng cho mọi khách hàng), các số này sẽ bị hạn chế hoặc không nhận (điền 0 vào ô bên cạnh mỗi loại). Chặn có hiệu lực trong 1 ngày."
                    + " Bỏ đánh dấu tất cả các đài để xoá chặn."
                }
            >

            </ConfirmDialog>
        </div >
    )
}
export default memo(ChanSoHang)